<form>
    <div class="dp-hidden position-absolute">
      <div class="input-group">
        <input
          name="datepicker"
          class="dp-hidden"
          ngbDatepicker
          #datepicker="ngbDatepicker"
          [autoClose]="'outside'"
          (dateSelect)="onDateSelection($event)"
          [displayMonths]="2"
          [dayTemplate]="t"
          outsideDays="hidden"
          [startDate]="fromDate!"
          tabindex="-1"
        />
        <ng-template #t let-date let-focused="focused">
					<span
            class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
          >
						{{ date.day }}
					</span>
        </ng-template>
      </div>
    </div>
    <div class="dropdown">
      <button class="btn btn-light btn-sm dropdown-toggle d-flex gap-2" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="bi-calendar-week"></i>
        <span>{{formattedRange}}</span>
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('Today')">Today</a></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('Yesterday')">Yesterday</a></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('This Week')">This Week</a></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('Last Week')">Last Week</a></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('This Month')">This Month</a></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('Last Month')">Last Month</a></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('This Year')">This Year</a></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="selectPredefinedRange('Last Year')">Last Year</a></li>
        <li><hr class="dropdown-divider"></li>
        <li><a class="dropdown-item" style="cursor: pointer;" (click)="openCustomDatepicker()">Custom</a></li>
      </ul>
    </div>
</form>
